import React, { Component } from 'react';

import PropTypes from 'prop-types';

import LazyLoadedImage from 'common/LazyLoadedImage';
import OAuthFlows from 'common/OAuthFlows';
import { H1 } from 'common/ui/Text';
import parseAPIResponse, { isDefaultSuccessResponse } from 'common/util/parseAPIResponse';

import AJAX from './AJAX';
import AuthButton from './AuthButton';
import Button from './inputs/Button';
import Tappable from './Tappable';

import GoogleIcon from 'img/google-icon.svg';

import 'css/components/_SignupForm.scss';

export default class SignupForm extends Component {
  static propTypes = {
    hasSuccessAction: PropTypes.bool.isRequired,
    oauthProvider: PropTypes.string,
    onEmail: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
    onOAuthSignup: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
  };

  state = {
    error: null,
    loading: null,
  };

  onOAuthFailure = (error) => {
    this.setState({
      error: 'Failed to connect, please try again!',
      loading: null,
    });
  };

  onOAuthContinue = (result) => {
    var OAuthFlow = OAuthFlows.getFlow(this.state.loading, 2);
    var flow = new OAuthFlow({
      onContinue: this.onOAuthContinue,
      onFailure: this.onOAuthFailure,
      onSuccess: this.onOAuthSuccess,
      redirectURL: null,
      separateWindow: null,
      shouldOpenNewTab: this.props.hasSuccessAction,
    });
    flow.connect(result);
  };

  onOAuthSuccess = (oauthData) => {
    this.login(oauthData);
  };

  login = (requestData) => {
    AJAX.post('/api/viewer/login', requestData, this.onLoginResponse.bind(this, requestData));
  };

  onLoginResponse = async (requestData, response) => {
    var responseObject;
    try {
      responseObject = JSON.parse(response);
    } catch (e) {
      responseObject = { error: 'server error' };
    }

    if (responseObject.user) {
      this.props.onSuccess();
      return;
    }

    if (responseObject.error === 'slow down') {
      this.setState({
        error:
          'You are trying to log in too many times. Please wait a few minutes before trying again.',
      });
      return;
    }

    if (!requestData.email || !requestData.name) {
      this.props.onOAuthSignup(requestData);
      return;
    }

    AJAX.post('/api/viewer/signup', requestData, this.onSignupResponse.bind(this, requestData));
  };

  onSignupResponse = (requestData, response) => {
    const { error } = parseAPIResponse(response, {
      isSuccessful: isDefaultSuccessResponse,
      errors: {
        'email domain is not trusted':
          'Canny does not accept disposable email addresses. Please, use another email address.',
        'slow down':
          'You are trying to log in too many times. Please wait a few minutes before trying again.',
        'email exists':
          'This email address is already associated with another Canny account, did you mean to log in?',
        'password is too weak': 'Please enter a stronger password.',
      },
    });

    if (!error) {
      this.props.onSuccess();
      return;
    }

    this.setState({ error: error.message });
  };

  renderErrorMessage() {
    if (!this.state.error) {
      return null;
    }

    return <div className="error">{this.state.error}</div>;
  }

  render() {
    return (
      <div className="signupForm">
        <div className="topContainer">
          <H1 variant="headingMd">Sign up for Canny with:</H1>
          <div className="buttons">
            <AuthButton
              authType="facebook"
              onFailure={this.onOAuthFailure}
              onSuccess={this.onOAuthSuccess}
              value={<div className="icon icon-facebook" />}
            />
            <AuthButton
              authType="google"
              onFailure={this.onOAuthFailure}
              onSuccess={this.onOAuthSuccess}
              value={<LazyLoadedImage alt="google logo" src={GoogleIcon} className="google" />}
            />
            <AuthButton
              authType="github"
              onFailure={this.onOAuthFailure}
              onSuccess={this.onOAuthSuccess}
              value={<div className="icon icon-github" />}
            />
            <div className="centeredDivider">OR</div>
            <Button
              buttonType="emailButton"
              onTap={this.props.onEmail}
              value={<div className="icon icon-email"></div>}
            />
          </div>
          <div className="note">
            We use Canny to collect feedback from users like you. Sign up to post and vote.
          </div>
          {this.renderErrorMessage()}
        </div>
        <Tappable onTap={this.props.onLogin}>
          <div className="accountModalCTA">
            <span>Already have an account? Log in</span>
          </div>
        </Tappable>
      </div>
    );
  }
}
